import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const FinanzierungRueckfall = () => {
  const [faelle, setFaelle] = useState([]);
  const [laeuft, setLaeuft] = useState(false);
  const laden = () => axios.get(`${API}/admin/finanzierung-rueckfall`).then((r) => setFaelle(r.data)).catch(() => setFaelle([]));
  useEffect(() => { laden(); }, []);
  if (!faelle.length) return null;
  const los = async (ids) => {
    if (!window.confirm(`${ids ? ids.length : faelle.length} Teilnehmer wieder auf „Bildungsgutschein“ setzen?`)) return;
    setLaeuft(true);
    try {
      const r = await axios.post(`${API}/admin/finanzierung-rueckfall/wiederherstellen`, { bestaetigt: true, teilnehmer_ids: ids || [] });
      toast.success(`${r.data.wiederhergestellt} Teilnehmer wiederhergestellt`);
      laden();
    } catch (e) { toast.error(e.response?.data?.detail || "Fehler beim Wiederherstellen"); }
    setLaeuft(false);
  };
  return (
    <div className="mb-6 rounded-xl border border-[#F0C9B8] bg-[#FBEDE7] p-4" data-testid="finanzierung-rueckfall">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="flex gap-3">
          <AlertTriangle className="h-5 w-5 text-[#B4502F] shrink-0 mt-0.5" />
          <div>
            <p className="font-semibold text-stone-900">{faelle.length} Teilnehmer wurden durch einen Speicherfehler von „Bildungsgutschein“ auf „Selbstzahler“ umgestellt</p>
            <p className="text-sm text-stone-700">Der Fehler ist behoben. Achtung: Die Liste enthält auch absichtliche Änderungen (z. B. echte Umstellung auf Einrichtung) – bitte jeden Fall prüfen und einzeln wiederherstellen.</p>
            <ul className="mt-2 text-sm text-stone-800 list-disc pl-5">
              {faelle.map((f) => <li key={f.teilnehmer_id}>{f.name} · {f.kurs} · umgestellt {new Date(f.umgestellt_am).toLocaleString("de-DE")}{f.von ? ` beim Speichern durch ${f.von}` : ""} · jetzt: {f.jetzt}
                <button onClick={() => los([f.teilnehmer_id])} disabled={laeuft} className="ml-2 text-xs font-medium text-[#B4502F] hover:underline" data-testid={`rueckfall-einzeln-${f.teilnehmer_id}`}>nur diesen wiederherstellen</button></li>)}
            </ul>
          </div>
        </div>
        <Button onClick={() => los()} disabled={laeuft} className="bg-stone-900 text-white hover:bg-[#D9775A]" data-testid="finanzierung-wiederherstellen-btn">
          Alle wiederherstellen
        </Button>
      </div>
    </div>
  );
};
